var _defs, _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.942,
    height: 19.942,
    viewBox: "0 0 19.942 19.942",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#50c150;}.b{fill:#fff;}"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 9.971,
    cy: 9.971,
    rx: 9.971,
    ry: 9.971
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.415,6.727l1.9-1.9v5.454a.828.828,0,1,0,1.655,0V4.823l1.9,1.9a.831.831,0,1,0,1.175-1.175L11.725,2.241a.856.856,0,0,0-1.175,0L7.239,5.552A.831.831,0,0,0,8.415,6.727Z",
    transform: "translate(-1.338 2.995)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnline);
export default __webpack_public_path__ + "static/media/online.1123492686ca0fbfc999e49f9cea819b.svg";
export { ForwardRef as ReactComponent };